import { environment } from "./util.environment.js";
import { makeEnvironmentRef } from "./util.make-environment-ref.js";
import { z } from "zod";
//#region src/env/parser.boolean.ts
var truthySchema = z.enum([
	"true",
	"1",
	"on",
	"yes"
]);
/**
* extract a boolean configuration from a string, considering only a strict
* subset of possible values as "true".
*/
function asBoolean(key, options) {
	return makeEnvironmentRef(() => {
		var _environment$read;
		const input = (_environment$read = environment.read(key, options)) === null || _environment$read === void 0 ? void 0 : _environment$read.toLowerCase();
		return truthySchema.safeParse(input).success;
	});
}
//#endregion
export { asBoolean };

//# sourceMappingURL=parser.boolean.js.map